import { useMemo } from 'react';
import { useStateSelector } from 'hooks';

import { ReportViewer } from 'components';

interface Props {
  entity?: 'contact-information' | 'maintenance/contact-information';
}

const ContactInformation: React.FC<Props> = ({
  entity = 'contact-information',
}) => {
  const { coopId, cooperatives } = useStateSelector((state) => ({
    coopId: state.settings.current_cooperative,
    cooperatives: state.home.cooperatives,
  }));

  const cooperative = useMemo(() => {
    return cooperatives.find((coop) => coop.Id === coopId) || null;
  }, [coopId, cooperatives]);

  return <ReportViewer cooperative={cooperative} entity={entity} />;
};

export default ContactInformation;
